// extracted by mini-css-extract-plugin
module.exports = {"filterWrapper":"styles_filterWrapper__0CTgt"};